// 产品
const json = [
    {
        id: 15,
        tit: '网银互联与Aryaka联合出席 CCA上海CIO领袖峰会',
        img: require("../../assets/about/news/chanpin/20201105/1.png"),
        date: '2020-11-05',
        text: "当新冠疫情遇上复工季，远程办公便成为时下最热办公模式。据统计，春节开工后，全国有过亿企业选择了远程办公。这种方式既保障了社会...",
        eassy:
            `
        <p>11月5日，2020 CCA上海CIO领袖峰会（CCA Summit 2020 SH）于上海历史博物馆拉开帷幕。本届峰会主题定为“ 从CIO到CxO的数字进化”，一起研究和探讨了在数字趋势下，人工智能、医疗保健、IT的演进，网络连接、网络安全等技术的发展。
        </p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20201105/1.png')}" alt=""></p>
        <p>本届的峰会论坛邀请了GE通用电气、Cisco思科等IT服务行业代表；摩根士丹利、工银安盛、FCA投资等金融行业代表；强生医疗、阿斯利康、拜耳中国等医疗行业代表；保时捷、沃尔沃、通用汽车等汽车行业代表；麦格纳、敏实集团、均胜电子、安沃驰等汽车供应链企业代表等80多位国际一线企业的CIO、CTO及COO亲临现场。
        </p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20201105/2.png')}" alt=""></p>
        <p>当日，网银互联作为Aryaka在中国地区战略合作方和服务商，受主办方邀请与Aryaka共同参加本届峰会。
        </p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20201105/3.png')}" alt=""></p>
        <p>Aryaka是全球一线的SDWAN托管服务商，也是本次峰会的重要嘉宾。在本届峰会上，Aryaka大中华区市场负责人Reagen Li先生就网银互联与Aryaka在中国区的合作成果发表了演讲，向参会的行业企业代表展示了由双方优势相结合的全球化企业组网服务能力。凭借Aryaka全球一流的产品与技术，以及全托管的方案理念；再结合网银互联丰富的骨干网络资源和优质的服务能力。相信能为企业全球化发展提供专业的解决方案，帮助实现真正的数字进化。
        </p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20201105/4.png')}" alt=""></p>
        <p>此前，Aryaka与网银互联达成合作，并借助网银互联基础网络设施建设能力，在中国区开设了多个POP点，这对于对网络全球化将是一个里程碑。未来，网银互联将以云优先的托管服务方法，结合Aryaka创新的SD-WAN技术，以零配置高速部署，全球范围不限地域，设备即插即用等优势，让企业主瞬间体验获得云时代的网络体验。
        </p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20201105/5.png')}" alt=""></p>
        
        `
    },
    {
        id: 14,
        tit: '网银互联受邀参加余杭跨境电商产业发展座谈会',
        img: require("../../assets/about/news/chanpin/20201030/2.png"),
        date: '2020-10-30',
        text: "2020年10月30日，由杭州市余杭区商务局和杭州跨境电商综试区联合举办的“余杭跨境电商产业发展座谈会”在余杭区市民之家商务局会议室召开...",
        eassy:
            `
        <p>2020年10月30日，由杭州市余杭区商务局和杭州跨境电商综试区联合举办的“余杭跨境电商产业发展座谈会”在余杭区市民之家商务局会议室召开。参加座谈会的有来自杭州综试办产业发展部部长梅金品、杭州综试办外联宣传部副部长陈健、杭州综试办管理服务中心周晨霞、杭州综试办管理服务中心张易舟等相关部门领导，亚马逊、全球速卖通、eBay、Shopee等诸多国际跨境电商平台代表以及新鹰户外、道器信息等十余家外贸电商企业代表，同时，杭州日报等媒体代表也出席了本次座谈会。</p>
        <p>与会企业代表、平台代表、服务商在高效务实的气氛中，对余杭区跨境电商企业现状、形势与未来展开了热烈讨论，并针对企业方存在的现实问题提出了建设性建议。</p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20201030/1.png')}" alt=""></p>
        <p>网银互联作为综试区网络优化服务商受邀参加本次座谈会，产品专家温园斌代表网银互联在本次座谈会上向各位领导、企业代表和服务商讲解展示了网银互联业务品牌LinkWAN在全球SaaS加速及网络优化层面的方案和成果。
        </p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20201030/2.png')}" alt=""></p>
        <p>LinkWAN基于网络即服务（NaaS）的理念，融合软件定义网络（SDN）及广域网优化技术（WAN Optimization）推出了新一代的SD-WAN解决方案。依托于全球近200个POP节点，LinkWAN在全球范围内构建了一张端到端网络，同时与阿里云、腾讯云、华为云、微软云、亚马逊等主流云服务商无缝对接，支持云、数据中心、分支机构之间的任意互联，可为全球电商企业提供和打造超高性价比、快捷部署的SD-WAN组网、云连接及SaaS应用高速访问服务，满足电商企业在快速组网、云网融合、敏捷网络、4G/5G应用、边缘计算、智能调度与管理等方面的个性化服务需求。
        </p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20201030/3.png')}" alt=""></p>
        `
    },
    {
        id: 13,
        tit: 'LinkWAN智能安全网关，助力企业网络安全建设',
        img: require("../../assets/about/news/chanpin/20201021/20201021.png"),
        date: '2020-10-21',
        text: "当新冠疫情遇上复工季，远程办公便成为时下最热办公模式。据统计，春节开工后，全国有过亿企业选择了远程办公。这种方式既保障了社会...",
        eassy:
            `
        <p>当新冠疫情遇上复工季，远程办公便成为时下最热办公模式。据统计，春节开工后，全国有过亿企业选择了远程办公。这种方式既保障了社会生活的正常运转，又能极大地减少面对面接触，一定程度上降低传染风险，保护人员健康安全。 </p>
        <p>停班不停工，企业开启远程办公模式后，如何保证公司业务的安全稳定运行，确保远程工作中，机密信息不被泄露，成为企业面临的巨大挑战。</p>
        <p class="tit" style="color:#3956c5">为什么要引入安全系列产品？</p>
        <P>自2017年《中华人民共和国网络安全法》颁布以来，明确要求网络安全是国家根本、基本国策和基本制度。2019年等保2.0发布，让网络安全从原本的注重主动防御，向事前、事中、事后全流程的安全可信、动态感知和全面审计，实现了对传统信息系统、基础信息网络、云计算、大数据、物联网、移动互联网和工业控制信息系统等级保护对象的全覆盖。</P>
        <p>纵观网络行业历史发展至今，病毒攻击、流量攻击、常规攻击层出不穷。2017年，勒索病毒肆虐，造成150个国家，30万用户、80亿美元的损失；据统计，中国境内每天发生的起DDOS/CC攻击高达数百起；而像病毒/木马/蠕虫攻击，流氓软件劫持，网页挂马/网站钓鱼，漏洞利用，这些经典安全攻击在网络中肆意传播，防不胜防。 </p>
    
        <p class="tit" style="color:#3956c5">LinkWAN智能安全网关解决方案</p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20201021/1.png')}" alt=""></p>
        <p>针对企业业务过程中经常出现的这些安全问题，网银互联LinkWAN推出了智能安全网关解决方案，可以对远程接入访问时，进行一系列的安全检测、防护，再结合安全网关上完善的内容与行为审计，可以真正做到事前防御、事中控制、事后审计的全业务流程防护，保证远程办公期间关键数据不被泄露，为企业网络的安全运行提供有利的保障。网银互联LinkWAN具备以下特性： </p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20201021/2.png')}" alt=""></p>
        `
    },
    {
        id: 12,
        tit: '内外兼修 | LinkWAN“远程办公”护航企业乘风破浪',
        img: require("../../assets/about/news/chanpin/20201015/20201015.png"),
        date: '2020-10-15',
        text: "根据外媒 The Verge 的报道，近日微软宣布：允许员工每周不超过 50% 的工作时间在家工作，经过经理批准后可以永久进行远程工作。微软并...",
        eassy:
            `
        <p>根据外媒 The Verge 的报道，近日微软宣布：允许员工每周不超过 50% 的工作时间在家工作，经过经理批准后可以永久进行远程工作。微软并不是唯一一个允许员工永久远程工作的公司。Facebook 正在将数万个工作岗位转移到远程工作上，首席执行官马克 · 扎克伯格向公众透露，在 5 到 10 年内，多达一半的员工可以远程工作。</p>
        <p>源于这场疫情，让“Work from Home”进入了公众的视野，但在远程办公过程中依然存在着诸多问题，其中最为基础的便是网络连接问题。本次LinkWAN新功能优化，正是针对远程办公这一需求。</p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20201015/1.png')}" alt=""></p>
        <p>企业员工既可通过LinkWAN CPE硬件设备，也可以通过LinkWAN VCPE软件配置接入LinkWAN骨干环网。通过VCPE接入的终端，同LAN接入/WiFi接入一样，具有同样的业务属性。且单个CPE设备，可匹配多至128个VCPE，极大地提高了设备的复用率和实用性。</p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20201015/2.png')}" alt=""></p>
        <p>企业员工在异地办公、居家办公、出差协同等多种远程办公场景下，仅需要通过远程终端LinkWAN VCPE简单配置，即可享受LinkWAN骨干环网带来的便捷组网体验。而同时，企业网络管理者，可通过Link GAIA可视化平台实时监控线路质量与带宽情况，可数据分析优化和控制线路情况。</p> 
        <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20201015/3.png')}" alt=""></p>
        
        `
    },
    {
        id: 11,
        tit: 'LinkWAN分钟级别开通反向加速|海外用户可稳定、高速访问国内应用',
        img: require("../../assets/about/news/chanpin/20200904/20200904.png"),
        date: '2020-09-04',
        text: "随着中国企业不断走出去，国内SaaS厂商的全球化服务日益增多，全球远程在线协同办公与跨域跨州长距离的访问国内应用等需求集中爆发。目前，海外...",
        eassy:
            `
            <p>随着中国企业不断走出去，国内SaaS厂商的全球化服务日益增多，全球远程在线协同办公与跨域跨州长距离的访问国内应用等需求集中爆发。目前，海外用户、员工访问国内网站及应用的体验不尽人意。复杂、多变的全球Internet环境为应用带来了前所未有的质量挑战，国内用户访问国内应用可以获得体验保障，但遍布全球的其他用户、员工则会被高抖动、高延时、高丢包所折磨，大大降低工作效率。</p>
            <P>为此，网银互联LinkWAN提出的反向加速解决方案<span style="color:#E86C00">高质量、高可靠、易开通、简运维</span></P>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200904/1.png')}" alt=""></p> 
            <p class="tit" style="color:#E86C00;text-align: center">LinkWAN核心优势</p>
            <p><span style="color:#E86C00">高质量</span> -时延大幅度降低，丢包率与抖动可降至0左右</p>
            <p>依托LinkWAN覆盖全球的骨干网和调度能力，实现网络就近接入和跨地域部署，减少延迟、抖动、丢包等网络问题对服务质量的影响，可以为客户提供多地域的应用访问优化、广域负载均衡和跨地域容灾能力。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200904/2.png')}" alt=""></p> 
            <p><span style="color:#E86C00">分钟级线上开通</span>-零配置开通，部署敏捷</p>
            <p>采用软件化部署，不影响用户现有网络环境</p>
            <p><span style="color:#E86C00">简运维</span>-智能管控平台</p>
            <p style="padding-top:20px">用户可通过Link GAIA可视化平台实时监控加速访问流量，自助开通需要反向加速的应用</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200904/3.png')}" alt=""></p> 
            
            <p class="tit"  style="color:#E86C00;text-align: center">应用场景一</p>
            <p>国内企业自建全球站，网站源部署在国内，海外用户及员工访问体验差，针对海外群体进行访问加速。</p>
            <p class="tit"  style="color:#E86C00;">客户案例</p>
            <p>国内某制造业厂商网站，国外用户经常遇到访问慢、延迟大等不稳定现象，LinkWAN帮助企业WEB反向加速，在使用LinkWAN加速后，海外用户访问速度变快，大幅度提升用户体验，为该企业在海外市场的拓展打下良好的基础。</p>
            <p class="tit"  style="color:#E86C00;text-align: center">应用场景二</p>
            <p>国内SaaS类企业开发的应用对外有开发集成接口，海外企业需调用相关API接口进行二次开发，但海外访问延迟高、不稳定，所以需要针对海外访问进行加速。</p>
            <p class="tit"  style="color:#E86C00;">客户案例</p>
            <p>国内知名语音识别SaaS厂商，对外能够通过API接口为第三方企业提供技术支持服务。但海外访问存在延迟高，访问慢等问题，使得企业开发的软件在用户侧使用效果不理想，在使用LinkWAN加速后，给海外用户提供稳定优质的访问体验，同时也帮助国内SaaS厂商更好地服务海外企业。</p>
            <p style="text-align: center;style="color:#E86C00;">扫码即可免费测试</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200904/4.png')}" alt="" style:"width:80px"></p> 
            `
    },
    {
        id: 10,
        tit: '重磅！云应用引擎HCaaS正式公测，让容器化开发没有门槛',
        date: '2020-08-28',
        img: require("../../assets/about/news/chanpin/20200828/20200828.png"),

        text: "今年8月，网银互联LinkCloud | HCaaS（Hybrid Container as a Service，混合容器即服务）正式上线公测。这是继私有化部署的魔方云之后...",
        eassy:
            `
            <p>今年8月，网银互联LinkCloud | HCaaS（Hybrid Container as a Service，混合容器即服务）正式上线公测。这是继私有化部署的魔方云之后，网银面向需要云资源的企业和个人开发者，推出的一款公有化云应用引擎平台。</p>
            <p>通过HCaaS，以K8S为代表的容器技术的门槛不再高高在上，无论用户的现有业务是基于镜像、源码、可执行文件，都可以方便地迁移到HCaaS，并享受只需专注业务本身的便捷。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200828/1.png')}" alt=""></p> 
            <p class="tit"  style="text-align: center">HCaaS相比自建容器的优势</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200828/2.png')}" alt=""></p> 
            <p>用户可通过微信、GitHub、用户名密码这些方式便捷地登录，登录后直接进行研发和部署，大大节省了前期准备和后期运维的时间。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200828/3.png')}" alt=""></p> 
            <p class="tit"  style="text-align: center">什么是HCaaS？</p>
            <p>HCaaS基于公有云和网银IDC的优质云资源搭建混合云，封装了docker&k8s容器技术，并通过开箱即用的组件为应用提供支撑和模块化开发的便捷体验。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200828/4.png')}" alt=""></p> 
            <p class="tit"  style="text-align: center">面向不同类型用户</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200828/5.png')}" alt=""></p> 
            <p>1、为了便于虚机习惯的用户，提供了容器虚机的功能，完全一致的用户体验</p>
            <p>2、对于想转容器的用户，提供了镜像构建等一键容器化；并且可以通过智能运维组件，登录容器、查看日志和事件来快速定位问题</p>
            <p>3、对于已使用容器的用户，通过快速部署按钮即可三步建站、或者部署一个应用</p>
            <p class="tit"  style="text-align: center">丰富的应用场景</p>
            <p class="tit">开发提效</p>
            <p>打通代码提交、代码构建、镜像构建、部署上线的研发交付全流程。DevOps管理多套环境(命名空间隔离)，资源秒级创建、用完释放，大大降低了人工和IT成本；通过自研的流水线缓存技术，可以极大地提高流水线的执行效率，加速2~6倍。</p>
            <p class="tit">快捷建站</p>
            <p>除了通过DevOps来持续迭代Web应用，HCaaS为尚未容器化的用户提供了快捷建站解决方案。通过选择技术栈、配置网站代码/可执行文件、配置Web域名等三步，分分钟搭建起一个Web服务。</p>
            <p class="tit">流量驱动</p>
            <p>面对业务量的起伏，外部流量的季节性波动。通过服务器负载指标和业务量指标监控，设定合适的阈值，弹性伸缩来应对流量洪峰。业务方可在短时间内启动大量处理节点，满足业务对海量计算资源的即时需求，用完即删，无需提前准备资源，最大限度的节省IT成本。</p>
            <p><span class='tit'>HCaaS目前处于公测阶段，登录领300元平台金，预计可免费试用4周起--cubepaas.com。</span>后续版本会提供一键启停、海外加速、块存储自定义配置等功能，并引入阿里云OSS、RDS等模块。让用户不再需要关心和运维底层IaaS和Kubernetes集群，只需专注于业务本身。</p>
            <p style="text-align: center">欢迎扫码加入HCaaS测试交流群！</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200828/6.png')}" alt="" style:"width:80px"></p> 
            <p style="text-align: center">如果群满或二维码过期失效，请添加 <span class='tit'>微信号：361205220</span> 邀请入群</p>
            `
    },
    {
        id: 9,
        tit: '网银互联HCaaS：提供混合云Serverless架构的容器服务',
        date: '2020-08-17',
        img: require("../../assets/about/news/chanpin/20200817/20200817.png"),

        text: "HCaaS（混合容器即服务 , Hybrid Container as a Service），是网银互联旗下的产品，是基本云概念CaaS（Container as a Service)的...",
        eassy:
            `
            <p class="tit" >HCaaS定义</p>
            <p>HCaaS（混合容器即服务 , Hybrid Container as a Service），是网银互联旗下的产品，是基本云概念CaaS（Container as a Service）的一种延伸，提供混合云Serverless架构的容器服务。通过搭建公有云和私有云的混合云基础设施，为用户提供以业务为中心而屏蔽底层资源和容器技术的平台服务。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200817/1.png')}" alt=""></p> 
            <p class="tit" ">HCaaS特性</p>
            <p style="margin-bottom:0">基础特性：自定义扩缩容，故障自愈，应用托管，镜像仓库。</p>
            <p>平台特性：一键部署，自动化流水线，智能运维组件，快速建站。</p>
            <p class="tit" >HCaaS优势</p>
            <p style="margin-bottom:0">通过结合公有云的平台能力和私有云高性价比的存量资源，HCaaS实现计算、网络、存储和组件资源的最优配置。混合部署的容器平台解决方案，兼顾了用户对于性能、成本和安全的综合需。</p>
            <p>用户可面向代码/可执行文件/镜像等多种方式使用，无需维护复杂的容器环境，可专注于自身的业务，一键开通后即可享受能自动扩缩容的云资源。</p>
            <p class="tit" ">HCaaS部署方式</p>
            <p style="margin-bottom:0">公有部署：部署在公有云和公共资源池，面向中小型企业和独立开发者的高性价比服务计算平台，支持秒级计费；</p>
            <p>私有部署：部署在用户的私有集群，与公有云通过高速通道连接，面向对安全性高要求的业务和企业。</p>
            `
    },
    {
        id: 8,
        tit: 'Salesforce体验不佳？LinkWAN助力企业优化访问体验',
        date: '2020-07-31',
        img: require("../../assets/about/news/chanpin/20200731/20200731.png"),

        text: "近日，全球最大的CRM服务商、SaaS云服务的代表Salesforce市值一度达到了1791亿美元。首次超过了曾经的全球第二大软件公司甲骨文（Oracle）...",
        eassy:
            ` 
            <p>近日，全球最大的CRM服务商、SaaS云服务的代表Salesforce市值一度达到了1791亿美元。首次超过了曾经的全球第二大软件公司甲骨文（Oracle）。这是一场SaaS之王和传统软件的旧霸主的交锋，意义不言自明。</p>
            <p>Salesforce是客户关系管理（CRM）软件的全球领导者，于2000年首推CRM革新理念，并将其服务扩展到新的领域和行业，引入了新功能和平台功能，其创新式云平台已成为世界首屈一指的CRM解决方案。Salesforce在中国也逐渐拥有了超过10万家企业客户，而Salesforce亚洲主要节点位于日本，国内公网访问存在<span class="tit" style="font-size:16px">高延迟、高丢包率</span>等问题，业务人员使用Salesforce系统经常出现操作无效、连接中断等现象，变相增加了工作量，同时CRM数据公网传输也存在隐性安全风险。</p>
            <p>针对Salesforce访问体验不佳的问题，网银互联旗下SD-WAN品牌LinkWAN提出了SaaS加速访问解决方案。LinkWAN国际出口通过专线直连Salesforce数据中心，为客户提供稳定优质的访问体验。</p>
            <p class="tit" style="text-align:center">LinkWAN解决方案</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200731/1.png')}" alt=""></p> 
            <p class="tit" >客户可通过2种接入方式访问海外的Salesforce SaaS应用</p>
            <p style:"margin-bottom: 0px;">1.通过LinkWAN CPE设备接入LinkWAN全球骨干网后，LinkWAN海外POP与日本Salesforce机房通过专线直连（Direct peering），采用BGP协议与Salesforce进行动态路由交换，确保了SaaS加速路由的实时性和完整性。</p>
            <p>2.通过专线直连LinkWAN全球骨干网，再通过出口专线直连Salesforce机房，全程专线接入，大大提升访问速度和体验。</p>
            <p>此外LinkWAN支持双WAN接入，可使用SD-WAN+专线互为备份，实现链路+设备+POP点多冗余，保障安全、稳定、高可用。</p>
            <p class="tit" style="text-align:center">LinkWAN产品优势</p>
            <p><span class="tit">高质量</span>-时延大幅度降低，丢包率与抖动可降至0左右</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200731/2.png')}" alt=""></p> 
            <p><span class="tit">分钟级两步线上开通</span>-零配置开局，部署敏捷，扩展快</p>
            <p>带宽、分支可弹性扩容，业务不受影响</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200731/3.png')}" alt=""></p> 
            <p><span class="tit">简运维</span>-智能管控平台</p>
            <p>用户可通过Link GAIA可视化平台<span class="tit">实时监控线路质量与带宽</span>，包括历史数据分析</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200731/4.png')}" alt=""></p> 
            <p>访问其他海外SaaS应用，你是否也遇到过以下情况：</p>
            <p>●Teams、Skype等音、视频会议经常卡顿？丢包率高？</p>
            <p>●Office365、Onedrive等文件下载速度慢？</p>
            <p>●Hubspot、ZOHO、Slack、Workday 等操作响应时间长？</p>
            <p>●SAP、Netsuite等频繁掉线甚至连不上？</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200731/5.png')}" alt=""></p> 
            `
    },
    {
        id: 7,
        tit: '新基建时代，企业数字化转型利器——魔方云',
        img: require("../../assets/about/news/chanpin/20200619/20200527.png"),
        date: '2020-05-27',
        text: "企业数字化转型已不再是个时髦的词汇，而是已经在各行各业悄然展开。在新基建的时代背景下，数字化转型大潮给企业IT平台带来了升级的需求。...",
        eassy:
            ` 
            <p>企业数字化转型已不再是个时髦的词汇，而是已经在各行各业悄然展开。在新基建的时代背景下，数字化转型大潮给企业IT平台带来了升级的需求。</p>
            <p class="tit">混合云或成为未来主流趋势 </p>
            <p>RightScale 云状态报告显示：共有81%的受访企业采用多云，其中21%采用多个公有云，10%采用多个私有云，而混合云的比例高达51%。对于如今大多数企业而言，混合云和多云(具有多个云，混合云的超集)与过去的多供应商一样已经成为现实。现在，企业工作数据越来越多地转移到云，但也出现了某些弊端 ，例如监管障碍、数据安全问题、对传统应用程序的依赖以及异常数据集等问题，这些已成为将整个企业数据迁移到公有云的最大障碍。而混合云模式利用公有云提供商的优势，同时保持私有云解决方案的速度和可靠性。</p>

            <p class="tit">容器越来越受到市场的认可 </p>
            <p>根据Gartner的预测，到2020年，所有领先的容器管理软件均内置服务融合技术，到2022年，有75%的全球化企业将在生产中使用容器化的应用。</p>

            <p class="tit">容器混合云成大趋势，解决开发和运维需求不对等难题 </p>
            <p>CNCF在2018年8月进行第六次测量容器管理市场的温度调研，结果显示83%的受访者更喜欢Kubernetes的容器管理工具，58%的受访者在生产中使用Kubernetes，42%的受访者正在进行评估以备将来使用，40%的企业（员工规模在5000+）正在使用Kubernetes。企业利用容器混合云平台主要是把包含公有云、私有云在内的各种基础端进行统一管理。例如，利用一个应用就可以跨越公有云和私有云来统一部署；可以在不同的云之间平滑迁移，跨云提供服务；在开发人员体会不到任何变化的同时，降低运维人员工作量等。</p>

            <p class="tit">容器越来越受到市场的认可 </p>
            <p>根据Gartner的预测，到2020年，所有领先的容器管理软件均内置服务融合技术，到2022年，有75%的全球化企业将在生产中使用容器化的应用。</p>

            <p class="tit">网银互联魔方云热存储迁移解决方案 </p>
            <p>魔方云利用混合云存储方式，存储数据到本地数据中心，是应对海量数据增长比较经济的方式。混合云存储意味着利用公有云存储和本地存储来创建更高的整体价值。当本地数据中心发生故障时，应用被调度至云上数据中心。当用户访问该应用时，云端系统检测是否有存储数据，若无数据，云端数据中心通过高速通道向本地数据中心发起请求，将用户访问的副本从本地迁移到云端，以保障数据完整性。同时魔方云无缝对接管理阿里云、腾讯云、AWS等国内外云管理服务商。魔方云可实现自动配置，一键迁移，解决企业IT面临的多云统一管理和迁移问题。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200619/640.png')}" alt=""></p> 
            `
    },
    {
        id: 6,
        tit: '网银互联顺利通过“SD-WAN Ready”测试权威认证',
        date: '2020-04-23',
        img: require("../../assets/about/news/chanpin/20200423/20200423.png"),
        text: "《网银互联顺利通过“SD-WAN Ready”测试权威认证》-- SD-WAN作为一种新的连接方式，在赋能AI、优化工业互联网、推动云网融合、加速5G部署...",
        eassy:
            ` 
            <p>SD-WAN作为一种新的连接方式，在赋能AI、优化工业互联网、推动云网融合、加速5G部署等多方面联动各产业共同发展，进而成为通信行业的热点。继“2019年SD-WAN产业发展论坛”顺利召开后，中国通信标准化协会SDN/NFV/AI标准与产业推进委员会（CCSA TC610 SDN）集成与互通测试组顺利启动“SD-WAN Ready测试项目”第二期。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/chanpin/20200423/1.png')}" alt=""></p> 
            <p class="tit">SD-WAN Ready测试项目是什么？ </p>
            <p>由中国通信标准化协会SDN/NFV/AI标准与产业推进委员会的SDN集成与测试工作组联合SDN技术与规范合作组发起，以垂直行业用户的共性需求为基准，结合当前SD-WAN产业发展水平，联合业内主流的运维服务提供商和解决方案提供商，制定基准测试规范，对齐各生态参与方解决方案、产品功能实现和服务标准，引导和促进产业发展。</p>
            <P>现阶段，“SD-WAN Ready”的测试认证项目将重点关注整体解决方案和运维服务评估，按照后续的工作规划，将分阶段逐步开展基于关键模块的能力评估和基于具体场景的测试评估工作。</P>
            <P>在本期测试中，<span class="tit" style="font-size:16px">网银互联通过了全面且严格的专业测试</span> ，验证了网银互联LinkWAN解决方案智能、高效和灵活的软件定义广域网能力。获得了整体解决方案模块证书。测试内容包括：<span class="tit" style="font-size:16px">自动化部署、链路质量监测、应用识别、负载均衡、动态路由、策略配置、用户自助管理、安全策略、安全隧道、URL过滤告警管理、可视化运维管理等功能</span>。此次测试验证了网银互联在为客户提供解决方案和丰富网络资源的同时，具备完善的SD-WAN运维能力，可以为企业客户提供一站式的SD-WAN完整服务。</P>
            <p style="text-align: center"><img style="width:360px" src="${require('../../assets/about/news/chanpin/20200423/2.png')}" alt=""></p> 

            <P>网银互联LinkWAN全场景SD-WAN的解决方案拥有智能调度，数据采集、分析、策略管理下发，构建全局动态在线网络业务模型，帮助用户实现企业IT数字化转型。</P>
            <p style="text-align: center"><img style="width:700px" src="${require('../../assets/about/news/chanpin/20200423/3.png')}" alt=""></p> 
            <p class="tit">● 即插即用，网络快部署，分支快上线 </p>
            <P> LinkWAN实现了设备的零配置上线，有效降低企业分支用户的IT技术依赖性，即使分支机构无专业网络运维人员也可轻松完成分支机构的网络快速开局。根据业务需求将应用进行灵活归类，定义应用对网络的需求，预留带宽和链路资源，对应用进行主动感知，实现业务的快速自动化部署。</P>
            <p class="tit">● 智能路由实现流量调度，保障企业核心业务不间断</p>
            <P>LinkWAN有效提升了广域网链路利用率，保障了业务质量与业务连续性，加强了对各类业务的管控与全局负载均衡，降低广域网专线链路支出。智能流量调度实现了链路的充分负载利用。可根据不同应用选择网络资源的质量和带宽，挑选适合应用的最佳路径。流量调度功能可根据网络变化提供自动化的流量调度，也可根据网络变化实现告警，在人工干预后实现调度功能，对网络健康状况做到了一目了然，有效降低运营成本。</P>
            <p class="tit">● 深度数据分析，实现流量可视化，洞察实时状态</p>
            <P>LinkWAN提供管理人员对业务质量的实施掌握手段，能够监控企业各IT应用的流量带宽行为，为后续链路扩容、优先级和带宽分配等工作提供准确的数据依据，实现用户从网络规划、部署实施到后期调优的全流程自动化、智能化，让用户更加聚焦于核心业务。</P>
            <p class="tit">● 简易运维，分钟级故障响应和问题处理</p>
            <P>由于网络规模庞大，在进行新业务的全网部署往往需要进行全网的业务配置。在发生网络安全问题时，进行快速端口控制或在进行特定业务的管控配置下发与收回资源上，传统手段往往耗费大量人力且易出现配置错误。采用LinkWAN方案后，实现了对内向业务部门、员工准确反馈问题，对外方便与运营商沟通，计算SLA。在出现链路故障后可迅速锁定链路问题，将平均4小时的排障时间缩短至10分钟。</P>
            <p style="text-align: center"><img  src="${require('../../assets/about/news/wxbt.png')}" alt=""></p> 

            `
    },
    {
        id: 5,
        tit: '贵公司的全球访问Salesforce体验爽吗？',
        date: '2020-03-26',
        img: require("../../assets/about/news/chanpin/20200326.png"),
        text: "《贵公司的全球访问Salesforce体验爽吗？》-- 目前Salesforce 在全球拥有200多万用户，连续五年被IDC评为全球第一的CRM，已然成为...",
        eassy:
            ` 
            <p>目前Salesforce 在全球拥有200多万用户，连续五年被IDC评为全球第一的CRM，已然成为国际CRM巨头。为实现企业全球化业务增长，中国企业出海热持续升温，国际企业也不断设立中国分公司。Salesforce在中国也逐渐拥有了超过10万家企业客户，但当国内访问Salesforce时，你是否遇到过丢包率高，常掉线，访问慢等问题？</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020.3.26/2.jpg')}" alt=""></p> 
            <p>我们该如何提升使用体验呢？</p>
            <p>以下为Salesforce已部署的海外机房：</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020.3.26/3.jpg')}" alt=""></p> 
            <p style="text-align: center">数据来源：salesforce官网</p>
            <p>基于Salesforce目前的海外数据中心，网银互联的Salesforce加速解决方案</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020.3.26/4.jpg')}" alt=""></p> 
            <p>通过Salesforce Express Connect，用户可从公共DNS上解析到Salesforce全球IP地址，可不经公网，直接通过云专线连接到Salesforce数据中心，同时以SD-WAN做备份，实现链路+设备+POP点多冗余高可用性。</p>
            <p>SEC是什么？定义：Salesforce云专线，是指用户通过专属线路访问Salesforce应用，可显着提高客户数据安全性，并且通过带宽和延时保证，大幅提高访问Salesforce应用的稳定性。</p>
            <span>SD-WAN是什么？</span>
            <p>定义：软件定义广域网，是指将SDN技术应用到广域网场景中所形成的一种产品或服务。这种产品或服务用于连接广阔地理范围的企业网络、数据中心、互联网应用及云服务，旨在帮助用户降低广域网的开支和提高网络连接灵活性。</p>
            <span>SEC+SDWAN解决方案</span>
            <p>1.客户通过专线接入LinkWAN国内POP点，再通过LinkWAN骨干到达Salesforce海外POP点；</p>
            <p>2.LinkWAN海外POP与海外Salesforce机房通过SEC互联；</p>
            <p>3.客户即可通过全程私有专线访问位于海外的Salesforce SaaS应用，并使用SD-WAN作为备份，实现链路+设备+POP点多冗余，保障安全、稳定、高可用。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020.3.26/5.jpg')}" alt=""></p> 
            <p style="text-align: center">方案拓扑图</p>
             <p>用户可通过LinkWAN可视化平台实时监控线路质量与带宽，包括历史数据分析</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020.3.26/6.jpg')}" alt=""></p> 
            <p style="text-align: center">客户收益</p>
            <p>敏捷部署：交付周期短业务访问加速，提升应用体验；网络从频繁掉线到稳定使用，丢包率可降至0%；可视化监控每一条链路的实时信息</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020.3.26/7.png')}" alt=""></p> 
            <p style="text-align: center">案例说话</p>
            <p>“没有使用SD-WAN的时候，我们访问salesforce非常卡顿、应用使用不流畅，使用后大幅增加了访问稳定性，达到0丢包无抖动状态，提高了工作效率。”​​</p>
            <p style="text-align: center">世界领先的生物制药公司</p>
            <p>“未上SEC前，数据同步经常丢失，对我们这样的医药行业很大影响，上SEC之后可以达到企业级别高稳定，0丢包0抖动，应用体验非常好。”</p>
            <p style="text-align: center">福利来了</p>
            <p style="text-align: center"><img style="width:300px;height:300px" src="${require('../../assets/about/news/2020.3.26/8.png')}" alt=""></p> 
             <p style="text-align: center">扫码即可免费申请SaaS应用加速（限额100位）</p>
            
            `
    },
    {
        id: 4,
        tit: '网银互联通过“SD-WAN Ready”权威认证，是下一代企业网的正确选择',
        date: '2020-01-19',
        img: require("../../assets/about/news/chanpin/20200119.png"),
        text: "2019年12月23日 至2020年1月3日，中国信通院SD-WAN项目组与杭州网银互联科技股份有限公司开展了SD-WAN整体解决方案测试...",
        eassy:
            ` 
            <p>2019年12月23日 至2020年1月3日，中国信通院SD-WAN项目组与杭州网银互联科技股份有限公司开展了SD-WAN整体解决方案测试的项目合作</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020-1.19/1.jpg')}" alt=""></p>
            <p>本次测试基于《SD-WAN整体解决方案测试规范》，项目测试组专家对网银互联的SD-WAN整体解决方案进行了评测，包括：验证了其设备支持自动化部署、链路质量检测、应用识别、负载均衡、动态选路、URL过滤、主备切换、网络转发等功能。
    本次测试充分验证了LinkWAN系统所有数据是经过AES加密，保证租网内的所有数据安全广域网优化，网络可实现近乎零丢包无抖动;系统支持控制器高可靠性，边缘设备高可靠性，链路高可靠性。</p>
            <p>LinkWAN系统支持不同网络拓扑结构的自动化部署能力，SD-WAN网络部署的经典模式包括单臂旁挂模式、三层网关模式、HA高可用模式、三层旁挂模式。</p>
            <p>LinkWAN系统的设备支持建立多条overlay加密隔离隧道进行视频应用流量以及流量转发速率，对应的128~1400各字节数据包转发吞吐集中在50~500Mbps。</p>
            <p>LinkWAN系统支持在管理节点上观察到邮件、文件共享、办公OA、视频、语音等多种应用流量以及流量对应的转发速率覆盖全球POP资源。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020-1.19/3.jpg')}" alt=""></p>
            <p>基于SD-WAN架构，LinkWAN具有全球交付能力，在全球建设了186个POP节点，在中国香港、新加坡、美国、德国等国家和地区都具备IDC节点资源，目前更多节点仍在持续建设中。</p>
            <p>与全球阿里云、腾讯云、华为云、微软云、亚马逊，谷歌云，IBM云， Salesforce，SAP，Oracle云等主流云服务商已完成对接互联。</p>
            <p>客户范围覆盖新零售、制造、互联网、金融、房地产、教育等行业。</p>
            <p>SD-WAN丰富的国内资源：国内以北京、上海、广州、深圳、杭州为一级骨干核心节点，覆盖大多数核心城市;100+国内POP节点和多层骨干专线互联，覆盖华北、华中、华东、华南等地区，覆盖北上广杭深等主要城市。</p>
            <p>主干线路带宽为100G以太网端口，环网固定带宽为2*100G， 可弹性扩到 1T以上。</p>
            <p>九大核心优势：高可用、多服务商链接、高质量、数据安全、高性价比、便捷可移动CPE、全球快速交付、全球专线网络、易管理。</p>
            <p>全生命周期服务与保障</p>
            <p>提供一对一服务，运维团队7*24小时守护，快速处理突发事件，工单快速响应，为客户提供便捷的客户服务体验。提供多种线路SLA解决方案，服务可靠性最高可达99.99%</p>
            <p>现场服务覆盖全国165个城市，一线城市和核心城市4小时以内，其余城市8小时以内到位。覆盖浙江、上海、北京、深圳、天津、安徽、广东、福建、江苏、辽宁、湖南、新疆 等28个省份。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020-1.19/4.jpg')}" alt=""></p>
            <p>LinkWAN应用于企业分支组网、新零售门店互联、智能制造、SaaS云应用访问加速等</p>
            <p>通过此次“SD-WANReady测试项目”，SD-WAN项目测试组专家通过技术合作对网银互联的SD-WAN整体解决方案进行了全面的测试，期待共建SD-WAN的开放生态。</p>
            <span>注：此次测试中，采用了思博伦通信公司的数据通信仪表Spirent TestCenter C1，以及网络损伤仪表Spirent SNE，为项目评估提供第三方的检测标准。</span>
            `
    },
    {
        id: 3,
        tit: '网银互联荣获第十四届中国IDC产业年度大典|2019年度SD-WAN优秀服务商',
        date: '2019-12-18',
        img: require("../../assets/about/news/chanpin/20191218.png"),
        text: "“中国IDC产业年度大典”是国内数据中心和云计算领域规模最大、最具影响力的标志性盛会。在主管部门的指导下，已连续举办十三届...",
        eassy:
            ` 
            <p>“中国IDC产业年度大典”是国内数据中心和云计算领域规模最大、最具影响力的标志性盛会。在主管部门的指导下，已连续举办十三届，总参会人数超过10万人。以“新基建，新产业，新格局”为主题的第十四届中国IDC产业年度大典(IDCC2019)将于2019年12月17-19日，在北京国家会议中心隆重举行。</p>        
            <p style="text-align: center"><img src="${require('../../assets/about/news/12.18/2.png')}" alt=""></p>
            <p>在2019年，网银互联基于企业客户自身需求，并依托强大生态资源加上智能管控平台，为行业企业提供易管理、高可用、灵活的组网方案。</p>
            <p style="text-align: center">荣获第十四届中国IDC产业年度大典</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/12.18/3.jpg')}" alt=""></p>
            <p style="text-align: center">2019年度SD-WAN优秀服务商</p>   
            <p style="text-align: center"><img src="${require('../../assets/about/news/12.18/4.jpg')}" alt=""></p>    
            <p style="text-align: center">基于SD-WAN架构，协助企业混合组网</p>
            <p>网银互联SD-WAN具有全球交付能力，一周之内开通业务，分支机构零配置。提供一揽子端到端的SD-WAN解决方案，从SD-WAN接入端，骨干网，控制器一直到管理平台，用户可以立即使用的服务构建一张自己的SD-WAN专网。</p>
            <p style="text-align: center">全生命周期服务</p>
            <p>1 V 1</p>
            <p>经验丰富的架构师提供一对一服务，为您的业务全程护航。</p>
            <p>7*24 H</p>
            <p>运维团队7*24小时守护，快速处理突发事件。</p>
            <p>5 MINS</p>
            <p>工单快速响应，为您提供便捷的客户服务体验。</p>
            <p>SLA保障</p>
            <p>提供多种线路SLA解决方案，最高可达99.99%。</p>
            <p>现场服务SLA解决方案</p>
            <p>现场服务覆盖165个城市，一线城市和核心城市4小时以内，其余城市8小时以内到位。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/12.18/5.jpg')}" alt=""></p>
            <p>今后，我们将持续通过全生命周期服务与强大的全球网关资源,为企业提供高效一站式的组网解决方案。</p>
            `
    },
    {
        id: 2,
        tit: 'Linkcloud技术实践日|与容器大牛面对面',
        date: '2019-11-18',
        img: require("../../assets/about/news/chanpin/20191108.png"),
        text: "传统的企业IT架构正变得越来越笨重，跟不上快速发展、灵活多变的业务需求，因此越来越的企业开始尝试新的架构方案...",
        eassy:
            ` 
            <p>传统的企业IT架构正变得越来越笨重，跟不上快速发展、灵活多变的业务需求，因此越来越的企业开始尝试新的架构方案，因轻量化、标准化而受到技术圈内追捧的容器技术，逐渐成为了新的技术潮流。</p>
            <p>如今容器技术已经日渐成熟，但具体到落地仍旧面临着不少难题，但关注点已经从“要不要容器化”进入到了“容器化如何落地”。</p>
            <p>在此背景下，由网银互联主办的Linkcloud技术实践日于11月16日在网金大厦举办，本次沙龙也邀请了来自个推、酷家乐、搜道网的容器技术大咖来到现场，分享各自的容器化落地案例，一同探讨容器化的未来之路！</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/11.18/2.png')}" alt=""></p>
            <p style="text-align: center">现场座无虚席</p>
            <p>来自容器社群中活跃的四位技术专家，将围绕微服务架构和容器技术分享实践经验，并针对Kubernetes及同类框架的实际应用进行主题演讲。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/11.18/3.png')}" alt=""></p>
            <p style="text-align: center">阿飞——个推的微服务实践之路</p>
            <p>第一位分享嘉宾是来自个推的应用平台研发部基础架构研发工程师阿飞，他从微服务化、API网关、容器化、Kubernetes实践这四个方面，介绍了个推目前的容器化状态、微服务框架，还详细分享了他们基于Kubernetes实现容器编排管理，基于service和coreDNS对服务注册和发现体系进行改造， 实现并完善相关的管理系统等实践经验。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/11.18/4.png')}" alt=""></p>
            <p style="text-align: center">东悦——酷家乐Kubernetes实践</p>
            <p>酷家乐容器化开发工程师东悦为我们分享了酷家乐选择容器化的原因以及一系列容器化历程。从遇到过的坑到希望今后的Kubernetes能运行一切：让k8s上的服务“活”的更好，并通过Operator支持更多复杂服务，他们会持续积极探索Knative、kubeflow的落地方案。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/11.18/5.png')}" alt=""></p>
            <p style="text-align: center">子何——搜道微服务容器化迁移实践</p>    
            <p>搜道网的子何向大家介绍了搜道基于.Net和Windows的微服务架构及集成的运维平台。从他们的迁移背景到基于Dockerfile+Gitlab+Jenkinsfile实现持续构建和集成。搜道的容器编排采用简单易用的Rancher，可主要解决动态扩容和资源利用率问题，尤其是多线开发资源申请问题的解决。他展望在满足业务需求的前提下能不断迭代、完善Devops，走有特色的Devops实践之路。</p>      
            <p style="text-align: center"><img src="${require('../../assets/about/news/11.18/6.png')}" alt=""></p>
            <p style="text-align: center">陶琪——网银互联基于容器的块存储使用</p> 
            <p>网银互联容器研发工程师陶琪向嘉宾分享了块存储的概念、作用、原理及功能等，并以实际测试数据进行了性能对比。并且，他在现场演示了魔方云数据备份与备份恢复等故障模拟操作，让听众更直观了解块存储使用步骤。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/11.18/7.png')}" alt=""></p>
            <p style="text-align: center">茶歇</p>  
            <p style="text-align: center"><img src="${require('../../assets/about/news/11.18/8.png')}" alt=""></p>
            <p style="text-align: center">提问交流环节</p>  
            <p style="text-align: center"><img src="${require('../../assets/about/news/11.18/9.png')}" alt=""></p>
            <p style="text-align: center">技术交流群</p>  
            <p style="text-align: center"><img src="${require('../../assets/about/news/11.18/10.png')}" alt=""></p>
            <p style="text-align: center">赠予到场者《互联网企业容器技术实践》书籍</p>  
            `
    },
    {
        id: 1,
        tit: "关于容器技术问题和混合云解答",
        text: "LinkCloud技术实践日·三月活动，现场大家的互动积极性都很高，活动后又陆续收到了一些关于容器技术问题和混合云...",
        date: "2019-03-09",
        img: require("../../assets/about/news/chanpin/20190309.png"),
        eassy:
            `
         <p>LinkCloud技术实践日·三月活动，现场大家的互动积极性都很高，活动后又陆续收到了一些关于容器技术问题和混合云的，我们挑选了一些解答。</p>
         <p style="text-indent:0;">问题1：一个请求过来如何访问到容器里的pod？<br />
         解答：<br />
         请求进入容器有集群内部和外部访问两种情况。<br />
         集群内部的访问请求是这样的:集群内部pod通过service name来进行访问，首先通过集群内部的域名服务(coredns,kube-dns)等解析出clusterIP,再通过kube-proxy服务配置的iptables规则或者ipvs规则将流量转发的endpoints。<br />
         集群外部访问：可以把svc类型配置成NodePort或LoadBalancer,如果集群提供负载均衡可以通过LoadBlanceer生成的EXTERNAL-IP来访问，也可以通过节点Ip和NodePort端口来访问，集群安装了ingress Controller的情况下，还可以通过配置ingress,外部通过Ingress的nginx做代理来访问容器。还能通过kubectl port-forward将服务从集群暴露出来，进行访问。<br />
         <br />
         问题2：容器是直接部署在物理机还是虚拟机上？<br />
         解答：<br />
         没有太大的要求，容器部署在物理机和虚拟机上没有太大的区别，只不过部署在虚拟机上会多一层虚拟机资源的操作和管理，增加了结构的复杂性。如果公司已经有现成的虚拟机管理平台，使用虚拟机能增加结构的灵活性，也挺好。具体选择要根据实际情况和人力成本来决定。<br />
         <br />
         问题3：多云混合情况下，master节点部署在哪里比较合适？<br />
         解答：<br />
         个人建议还是放在线下机房比较合适，这样有更高的可控性。当然如果有自己的特殊情况或需求另说，具体部署在哪里没有太大的限制要求，可以视情况而定。
         </p>
           `
    },
    {
        id: 0,
        tit: "互联网企业容器技术实践",
        text: "由杭州网银互联携手沃趣科技、蘑菇街就自身的产品研发以及信息化管理方面对容器技术进行了各自的经验分享...",
        date: "2019-03-05",
        img: require('../../assets/about/news/chanpin/20190305.png'),
        eassy:
            `
            <p>由杭州网银互联携手沃趣科技、蘑菇街就自身的产品研发以及信息化管理方面对容器技术进行了各自的经验分享。同时，本次还邀请到了华为云容器技术专家分享了技术发展与实践等内容，为活动增添了更深的行业理解与技术高度.</p>
            <p>活动现场收到了近百人的积极报名参与，涉及到的企业共70家，分别来自于互联网、金融、制造业以及媒体行业。开场，杭州网银互联公司副总经理，LinkCloud品牌负责人许琴首先感谢现场学习者的到来，她介绍说，网银互联作为浙江地区中立IDC领导者，一直致力于企业用户大数据底层和云计算应用层服务。随着业务的积累，公司已不仅限于数据环境的基础设施能力，更可以提供多云部署和资源弹性配置，帮助企业IT架构实现高效敏捷的混合云环境。同时就企业用户在选择容器技术的革新融入、多云环境应用以及容器技术的最终落地三个方面表达了观点，这也是LinkCloud组织这一系列交流分享活动的初衷。随后，华为云容器混合云专家江舒杭，作为第一位演讲嘉宾，对容器技术的行业发展、应用价值以及华为云容器混合云实践案例进行分享。第二位分享者来自于蘑菇街的容器高级技术专家范德良，就蘑菇街基于K8S的机器学习平台实践做分享。沃趣科技一直专注于企业数据库的产品和技术研发以及客户服务，本次作为共同主办方，由其研发高级工程师叶龙宇为现场分享容器化RDS——关于K8S应用服务暴露实践。最后，网银互联研发负责人,高级架构师何小波作最后分享，介绍了网银云服务架构如何融合IDC基础设施的核心资源，并通过容器技术实现企业高敏的应用环境以及混合云环境。本次活动，台下的学习者与分享嘉宾形成了良好的互动，提出了各自工作或学习中的技术问题，并得到了相应的解答和建议。活动最后，本次的另一个重点，由网银互联发起，携手网易、沃趣科技、蘑菇街、酷家乐、个推、纵横新创、搜道网、九言科技8家企业共同撰写的《互联网企业容器技术实践》书籍，现场赠与每一位参会者，把最有实践价值的大量干货分享给大家，希望能够带去帮助和启发。</p>
           `
    }
]

export default json;


// WEBPACK FOOTER //
// ./src/view/about/newinfos.js